import z from 'zod';

export const paginationSchema = z.object({
  page: z.number().default(1).optional(),
  perPage: z.number().default(10).optional(),
});

export type Pagination = z.infer<typeof paginationSchema>;
